import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import canEditBoardContent from '../utils/can-edit-board-content';
import Board from '../components/Board';

const mapStateToProps = (state) => {
  let { cardId } = selectors.selectPath(state);
  const currentUser = selectors.selectCurrentUser(state);
  const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);

  const boardData = selectors.selectCurrentBoard(state);
  let listIds = selectors.selectListIdsForCurrentBoard(state);

  if (boardData.is_archive) {
    listIds = [];
    cardId = null;
  }

  const listReportDataById = (listIds || []).reduce((acc, id) => {
    acc[String(id)] = selectors.selectListReportDataByListId(state, id);
    return acc;
  }, {});

  return {
    listIds,
    listReportDataById,
    isCardModalOpened: !!cardId,
    canEdit: boardData.is_archive
      ? false
      : canEditBoardContent(currentUser, currentUserMembership),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onListCreate: entryActions.createListInCurrentBoard,
      onListMove: entryActions.moveList,
      onCardMove: entryActions.moveCard,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Board);
